import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export const isEmpty = (value) => {
    if (value === null) {
        return true;
    }
    if (typeof value !== 'number' && value === '') {
        return true;
    }
    if (value === 'undefined' || value === undefined) {
        return true;
    }
    if (value !== null && typeof value === 'object' && !Object.keys(value).length) {
        return true;
    }
    return false;
};

export const validateFileType = (path) => {
    const ALLOWED_EXT = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    let isValid = true;
    if (!ALLOWED_EXT.exec(path)) return (isValid = false);
    return isValid;
};

export const getLoggedUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : {};
};

export const sendRequest = async (url, data) => {
    const method = data.method || 'post';
    const payload = data.payload || {};
    const headers = data.headers || {};
    let token = payload.token;

    // if (isEmpty(token)) {
    //     const user = getLoggedUser();
    //     token = user._token;
    // }

    let axios_config = {
        method: method,
        url: url,
        headers: {
            'x-access-token': token,
            ...headers
        },
        validateStatus: () => true //Always resolve promise on every http status
    };
    if (method == 'get') {
        axios_config['params'] = payload;
    } else {
        axios_config['data'] = payload;
    }
    try {
        const response = await axios(axios_config);
        if (response.status === 401) {
            //User's Token has been expired
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return response;
    } catch (error) {
        return error;
    }
};

export const successToast = (str) => {
    toast.success(str);
};

export const errorToast = (str) => {
    const text = str.replace('-', '<br/>');
    const textHtml = <span dangerouslySetInnerHTML={{ __html: text }}></span>;
    toast.error(textHtml);
};

export const getCities = (provinceData, selectedProvince) => {
    const province = provinceData.filter((data) => {
        if (data.provinceName == selectedProvince) {
            return data;
        }
    });
    return province[0].cities;
};
export const errorMessageString = (err) => {
    if (typeof err === 'object' && err !== null) {
        // If the error is an object, you might want to check for a specific property like message
        return err?.message || JSON.stringify(err);
    } else {
        // If the error is not an object, convert it to string
        return String(err);
    }
};

export const calculateAnswered = (data, includeDynamicQuestion) => {
    try {
        if (typeof data !== 'object' || data === null) {
            return 0;
        }
        let answeredCount = 0;
        Object.values(data).forEach((field) => {
            if (typeof field === 'object' && field !== null) {
                const values = Object.values(field).filter((f) => typeof f === 'string');
                if (values.some((v) => v.length > 0)) {
                    answeredCount++;
                }
            }
        });
        return answeredCount;
    } catch (error) {
        return 0; // Return 0 if JSON parsing fails
    }
};

export const validateCanadianPostalCode = (postalCode) => {
    const regex = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
    return regex.test(postalCode);
};

export const formatPostalCode = (value) => {
    // Remove all spaces and ensure uppercase letters
    let formatted = value.replace(/\s/g, '').toUpperCase();

    // Restrict to first 6 valid characters
    if (formatted.length > 6) {
        formatted = formatted.substring(0, 6);
    }

    // Insert a space after the third character
    if (formatted.length > 3) {
        formatted = formatted.slice(0, 3) + ' ' + formatted.slice(3);
    }

    return formatted;
};

export const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const roundToInteger = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
        return null;
    }
    return Math.round(parseFloat(value));
};
